import conditionals from './conditionals';

export default conditionals;
